import React from 'react';

const Experience = ({ 
    register, 
    errors, 
    defaultValue, 
    value, 
    handleExpChange 
}) => {
    const numbers = Array.from({ length: 5 }, (_, index) => index + 1);

    // If using React Hook Form
    if (register) {
        return (
            <div className="addSelect">
                <select 
                    {...register('exp', { 
                        required: 'Experience is required: 1=Noob, 5=Expert' 
                    })} 
                    defaultValue={defaultValue}
                >
                    {numbers.map(num => (
                        <option key={num} value={num}>
                            {num}
                        </option>
                    ))}
                </select>
                {errors.exp && <span>{errors.exp.message}</span>}
            </div>
        );
    }

    return (
        <select 
            value={value} 
            onChange={(e) => handleExpChange(e.target.value)}
        >
            {numbers.map(num => (
                <option key={num} value={num}>
                    {num}
                </option>
            ))}
        </select>
    );
};

export default Experience;